import ERROR from "../images/error.png";
import SUCCESS from "../images/success.png";

const IMAGES = {
    ERROR,
    SUCCESS,
};

export default IMAGES;
